module.exports = __webpack_public_path__ + "static/media/valletta_malta.673e08cf.jpg";